<template minapp="mpx" xlang="wxml">
  <view class="expand-wrap" wx:style="{{expandWrapStyle}}" wx:if="{{show}}">
    <view class="recommend-title">同车有票方案</view>
    <view class="expand" wx:for="{{ refactorTicketData }}">
      <!-- <guide-tips wx:if="{{isPreScramble}}"  pageType="makeOrderDetail" trainInfo="{{trainInfo}}"/>
      <marke-order-guide  list="{{trainInfo?.estimate_banner}}" wx:else /> -->
      <view
        wx:class="es-seat-information"
        wx:style="{{refactorTicketData.length <= 3 ? 'justify-content:space-between':''}}"
        wx:if="{{refactorTicketData}}"
      >
        <view class="es-card-container" >
          <view class="es-card" wx:key="index">
            <!-- 坐席 -->
            <view class="es-ticket-left">
              <view class="es-seat-type-name">
                <view class="es-seat-type-name-text"
                  >{{ item.seat_type_name }}
                  <view class="student-tag" wx:if="{{item.is_student}}">学</view>
                </view>
              </view>
              <!-- 价格 -->
              <view class="es-ticket-price" bindtap="showTicketDetail(item)">
                <text class="es-ticket-price-num"> ￥{{ item.show_price }} </text>
                <svg
                  wx:if="{{item.showSleeperSeat}}"
                  class="triangle-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  fill="none"
                  version="1.1"
                  width="7"
                  height="4"
                  viewBox="0 0 7 4"
                >
                  <g
                    transform="matrix(1,-2.2348338291067193e-8,2.2348338291067193e-8,-1,-8.939335666040634e-8,8.000000312876736)"
                  >
                    <path
                      d="M4.00172,4.573392156438368L6.03254,6.894330156438368C6.40971,7.3253901564383685,6.10359,8.000000156438368,5.53082,8.000000156438368L1.46918,8.000000156438368C0.896406,8.000000156438368,0.590288,7.3253901564383685,0.967461,6.894330156438368L2.99828,4.573392156438368C3.26389,4.269840156438368,3.73611,4.269840156438368,4.00172,4.573392156438368"
                      fill-opacity="1"
                    />
                  </g>
                </svg>
                <view class="coupon-desc" wx:if="{{item.discount_desc}}">{{
                  item.discount_desc
                }}</view>
              </view>
            </view>
            <view class="es-ticket-right">
              <!-- 票状态 -->
              <view class="es-ticket-remainder">
                <view wx:if="{{isPreScramble}}"></view>
                <view
                  wx:elif="{{item.ticket_num === '无票' && !fromChangeTicket}}"
                  wx:style="color: #999999"
                  >无票</view
                >
                <view wx:else>{{ item.ticket_num }}</view>
              </view>
              <!-- btn-->
              <view catchtap="selectSeat(item)">
                <block wx:if="{{fromChangeTicket}}">
                  <view
                    class="es-ticket-btn"
                    wx:style="{{selectSeatInfo.ticket_price && item.ticket_num !== '无票'? '':'background: #CCCCCC'}}"
                    >预订</view
                  >
                </block>
                <block wx:else>
                  <view
                    class="es-ticket-btn"
                    wx:if="{{isPreScramble}}"
                    wx:style="background: #FF4129;"
                    >预约</view
                  >
                  <view
                    class="es-ticket-btn"
                    wx:elif="{{item.ticket_num === '无票'}}"
                    wx:style="background: #FF4129;"
                    >抢票</view
                  >
                  <view class="es-ticket-btn" wx:else>预订</view>
                </block>
              </view>
            </view>
          </view>
          <view class="recommend">
            <view class="recommend-tips">
              <view>{{item.tag}}</view>
              <view class="recommend-gap"></view>
              <hl-text text="{{item.title}}" hlColor="{{item.hightlight}}" hlStyle="{{{fontWeight: '800'}}}"></hl-text>
            </view>
            <more-less-guide guide="{{getRecommendGuide(item)}}" isMakeOrder="{{true}}"/>
          </view>
        </view>
      </view>
      <price-detail-info-alter
        show="{{ showPriceEstimation }}"
        title="{{ priceEstimation.title }}"
        priceDetail="{{ priceEstimation.detail }}"
        priceDetailCardTip="卧铺价格仅供参考，以实际出票结果收取费用"
        bind:close="closePriceEstimation"
        customStyle="{{lowerDrawer}}"
      />
    </view>
  </view>
  <!-- 百川授权弹窗 -->
  <Privacy
    wx:if="{{showPrivacy}}"
    list="{{baichuanTrainPrivacy}}"
    bind:privacyVerify="privacyVerify"
  />
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { getStorage, setStorage } from '@/utils/storage'
  import { STORAGE_TRAIN_INFO, STORAGE_DETAIL_SEARCH_QUERY } from '@/utils/train-storage'
  import { getFinalPrice } from '@/utils/money'
  import { innerRouter, pagePath } from '@/common/jump'
  import { SLEEPER_SEAT_TYPE, LOAD_FAIL_CONTENT } from '@/common/constant'
  import { to12306LoginPage } from '@/common/pageJump'
  import { trackEvent } from '@/common/track'
  import { getURL } from '@didi/webx-js'
  import { formatRecommendTicketDrawer, formatRecommendTicketGuide } from '@/utils/recommend'
  import dayjs from 'dayjs'

  createComponent({
    pageLifetimes: {
      show: function () {
        // 多买少买从填单页回退到坐席选择后，需要把车次回退到原始车次
        const localTrainDetail = getStorage(STORAGE_DETAIL_SEARCH_QUERY)
        localTrainDetail?.ticket_data?.forEach(item => {
          item.show_price = getFinalPrice(item.coupon_after_price) || 0,
          item.showSleeperSeat = SLEEPER_SEAT_TYPE.includes(item.seat_type) && (item.seatS_ticket_price || item.seatX_ticket_price || item.seatZ_ticket_price)
          return item
        })
        this.setTrainDetail({ ...localTrainDetail, noNeedSelectSeatInfoInit: true })
      }
    },
    props: {
      isStudent: {
        type: Boolean,
        value: false
      },
      fromChangeTicket: {
        type: Boolean,
        value: false
      },
      isPreScramble: {
        type: Boolean,
        value: false
      },
      hasRightsChoosed: {
        type: Boolean,
        value: false
      }
    },
    data: {
      lowerDrawer: {
        height: '252px'
      },
      showPriceEstimation: null,
      priceEstimation: {
        title: '价格预估',
        detail: {}
      },
      isExpand: true,
      showPrivacy: false
    },
    watch: {
      refactorTicketData: {
        deep: true,
        handler(val) {
          const { refreshType } = this.trainInfo || {}
          if (refreshType === 'coupon') {
            const info = val?.find(
              (item) => item.seat_type_name === this.selectSeatInfo.seat_type_name
            )
            this.setSelectSeatInfo(info)
          }
        }
      }
    },
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo',
        trainInfo: 'train.trainInfo',
        ticketData: 'train.ticketData',
        recommendTicket: 'train.recommendTicket',
        showRecommendTickets: 'train.showRecommendTickets',
        baichuanTrainPrivacy: 'common.baichuanTrainPrivacy'
      }),
      show() {
        return this.showRecommendTickets && this.refactorTicketData?.length && !this.hasRightsChoosed && this.isSameType
      },
      isSameType() {
        return this.recommendTicket.some(item=>item.seat_type === this.selectSeatInfo?.[0]?.seat_type)
      },
      expandWrapStyle() {
        if (this.isExpand) {
          return {
            opacity: 1,
            'grid-template-rows': '1fr'
          }
        } else {
          return {
            opacity: 0,
            'grid-template-rows': '0fr',
            overfow: 'hidden'
          }
        }
      },
      retractStyle() {
        if (this.isExpand) {
          return {
            opacity: 0,
            height: 0
          }
        } else {
          return {
            opacity: 1,
            height: '48px'
          }
        }
      },
      refactorTicketData() {
        const ticketData = this.recommendTicket
        return ticketData?.map?.((item) => {
          const {
            ticket_price,
            coupon_after_price,
            seat_type,
            seatS_ticket_price,
            seatX_ticket_price,
            seatZ_ticket_price
          } = item
          return {
            ...item,
            show_price: getFinalPrice(coupon_after_price||ticket_price) || 0,
            showSleeperSeat:
              SLEEPER_SEAT_TYPE.includes(seat_type) &&
              (seatS_ticket_price || seatX_ticket_price || seatZ_ticket_price)
          }
        })
      }
    },
    methods: {
      ...store.mapMutations({
        setSelectSeatInfo: 'train.setSelectSeatInfo',
        setMakeOrderLoginType: 'makeOrder.setMakeOrderLoginType',
        setTrainDetail: 'train.setTrainDetail',
        setRecommendCardInfo: 'train.setRecommendCardInfo',
        setExpectTicket: 'train.setExpectTicket',
        setBaichuanTrainPrivacy: 'common.setBaichuanTrainPrivacy',
        setResetSelectSeatForRecommendBack: 'common.setResetSelectSeatForRecommendBack',
      }),
      ...store.mapActions({
        getCurrentUserReverse: 'login12306.getCurrentUserReverse'
      }),
      getRecommendGuide(item) {
        const test = {...this.trainInfo, recommend_ticket: item}
        const guide = formatRecommendTicketGuide(test)
        return guide
      },
      // 卧票价格具体信息相关
      openPriceEstimation(detail) {
        const { seat_type_name, seatS_ticket_price, seatX_ticket_price, seatZ_ticket_price } = detail
        const seats = [
          {
            name: '上铺',
            value: seatS_ticket_price
          },
          {
            name: '中铺',
            value: seatZ_ticket_price
          },
          {
            name: '下铺',
            value: seatX_ticket_price
          }
        ].filter(({ value }) => value)
        this.priceEstimation = {
          title: `${seat_type_name}价格预估`,
          detail: {
            fee_info: [
              {
                fee_item: seats.map(({ name, value }) => {
                  return {
                    name: `${seat_type_name}${name}`,
                    value: `¥ ${getFinalPrice(value) || 0}`,
                    bold: true,
                    pixel: '14px',
                    color: '#333333'
                  }
                })
              }
            ]
          }
        }
        this.showPriceEstimation = true
      },
      closePriceEstimation() {
        this.showPriceEstimation = false
      },
      triggerExpand() {
        this.isExpand = !this.isExpand
      },
      selectSeat(item) {
        if (this.baichuanTrainPrivacy?.title) {
          // 有待签署协议，需要展示签署弹窗
          return this.showPrivacy = true
        }
        const trainInfoRecommend = {
          ...this.trainInfo,
          from_station_name: item.from_station_name,
          to_station_name: item.to_station_name,
          noNeedStorage: true
        }
        const expectTicket = {
          ...trainInfoRecommend,
          expect_from_station: this.trainInfo.from_station_name,
          expect_to_station: this.trainInfo.to_station_name,
          diff_station_num: item.diff_station_num,
          diff_amount: item.diff_amount,
          type: item.type,
          expect_start_time: dayjs(this.trainInfo.start_time).unix(),
          expect_arrive_time: dayjs(this.trainInfo.arrive_time).unix()
        }
        if(this.trainInfo?.is_ticket_period && this.userGroup){
          this.setMakeOrderLoginType(1)
        }else{
          this.setMakeOrderLoginType(0)
        }
        this.setExpectTicket(expectTicket)
        this.setRecommendCardInfo(formatRecommendTicketDrawer({...this.trainInfo, recommend_ticket: item}))
        this.setTrainDetail(trainInfoRecommend)
        this.setSelectSeatInfo([item])
        this.setResetSelectSeatForRecommendBack(true)
        innerRouter.push(pagePath().MAKEORDERBACKUP, {
          from: this.from,
          isRecommend: true
        })
      },
      goStudent() {
        // 跳转学生票说明页
        innerRouter.push(pagePath().ICKETPURCHASENOTICE, {
          checkTabIndex: 'student'
        })
      },
      showTicketDetail(ticket) {
        if (ticket.showSleeperSeat) {
          this.openPriceEstimation(ticket)
        }
      },
      privacyVerify(val) {
        const isComfirm = val.detail
        this.showPrivacy = false
        if (isComfirm) {
          this.setBaichuanTrainPrivacy({})
        }
      },
    },
    onUnload() {
      this.selectSeat({})
    }
  })
</script>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  .expand-wrap
    // display grid
    overflow hidden
    max-width 100%
    transition grid-template-rows 0.5s 0s, opacity 0.5s 0.1s
  .recommend-title
    font-size 14px
    line-height 16px
    color #333333
    margin-top 20px
    margin-bottom 12px
    font-weight 800
  .recommend-tips
    margin-bottom 5px
  .retract
    display flex
    flex-direction row
    align-items center
    justify-content space-between
    background #FFFFFF
    height 48px
    padding 0 23px 0 14px
    border-radius 8px
    transition height 0.3s 0s, opacity 0.3s 0.1s
    .left
      display flex
      flex-direction row
      align-items center
      .seat
        font-family PingFang SC
        font-size 16px
        font-weight 800
        line-height 16px
        letter-spacing 0px
        color #333333
      .price
        font-family Barlow Semi Condensed
        font-size 18px
        font-weight 400
        line-height 18px
        text-align center
        letter-spacing 0px
        color #333333
      .coupon-desc
        margin-left 5px
        padding 1.5px 2px
        box-sizing border-box
        border 1px solid #CCCCCC
        border-radius 3px
        font-family PingFang SC
        font-size 9px
        font-weight normal
        line-height 9px
        text-align right
        letter-spacing 0px
        color #999999
    .action
      font-family PingFang SC
      font-size 14px
      font-weight normal
      line-height 14px
      text-align right
      letter-spacing 0px
      color #999999
      position relative
      &::after
        position absolute
        content ''
        right -11px
        top 4.5px
        width 8px
        height 4.5px
        background-image url('https://ut-static.udache.com/webx/sfc/bbrbRrhKu8Dh67eMxzptV.png')
        background-size contain
        background-repeat no-repeat
  .expand
    background #FFFFFF
    border-radius 8px
    min-height 0
    margin-bottom 8px
  .student-notice
    font-size 12px
    font-weight 400
    color #999999
    margin 18px 18px 0px 14px
    display flex
    flex-direction row
    justify-content space-between
    align-items center
    .student-notice-left
      display flex
      flex-direction row
      justify-content flex-start
      align-items center
      flex 1
      .student-notice-tag
        font-size 10px
        line-height 13px
        font-weight normal
        font-family PingFang SC
        color #27BF6B
        width 44px
        height 14px
        margin-right 4px
        box-sizing border-box
        border 0.5px solid rgba(39, 191, 107, 0.6)
        border-radius 3px
        text-align center
      .title
        font-family PingFang SC
        font-size 12px
        font-weight normal
        line-height 16px
        letter-spacing 0px
        color #666666
        flex 1
    .student-notice-right
      position relative
      font-family PingFang SC
      font-size 12px
      font-weight normal
      line-height 11px
      letter-spacing 0px
      color #666666
      &::after
        position absolute
        content ''
        right -9px
        top 1.5px
        width 4.5px
        height 8px
        background-image url('https://ut-static.udache.com/webx/sfc/u2SPUJglRdRt6P8oLrC8k.png')
        background-size contain
        background-repeat no-repeat
  .es-seat-information
    display flex
    flex-direction column
    justify-content flex-start
    white-space nowrap
    flex-wrap nowrap
    // padding 0 14px 3px 14px
    background #FFFFFF
    border-radius 8px
    margin-bottom 8px
    padding-bottom 2px
    .es-card-container
      border-bottom 0.5px solid #EEEEEE
    .es-card
      flex-shrink 0
      position relative
      box-sizing border-box
      display flex
      flex-direction row
      align-items center
      height 65px
      box-shadow none
      justify-content space-between
      padding 0 14px
      &:last-child
        border-bottom none
      .es-ticket-left
        display flex
        flex-direction row
        justify-content flex-start
        flex 1
        .es-seat-type-name
          font-size 16px
          text-align center
          display flex
          flex-direction row
          justify-content flex-start
          align-items center
          font-family PingFang SC
          font-weight 500
          line-height 16px
          letter-spacing 0px
          color #333333
          position relative
          min-width 72px
        .es-seat-type-name-text
          position relative
          display flex
          flex-direction row
          justify-content flex-start
          align-items center
          .student-tag
            font-size 10px
            line-height 14px
            font-weight normal
            font-family PingFang SC
            color #27BF6B
            width 14px
            height 14px
            margin-left 4px
            box-sizing border-box
            border 0.5px solid rgba(39, 191, 107, 0.6)
            border-radius 3px
            text-align center
            position absolute
            right -18px
        .es-ticket-price
          white-space nowrap
          display flex
          align-items center
          .es-ticket-price-num
            display inline-block
            font-family Barlow Semi Condensed
            font-size 22px
            font-weight 400
            line-height 22px
            text-align center
            letter-spacing 0px
            color #FF6400
          .triangle-icon
            margin-left 2px
            fill #FF6400
          .coupon-desc
            margin-left 5px
            padding 1.5px 2px
            box-sizing border-box
            border 1px solid #FFBC91
            border-radius 3px
            font-family PingFang SC
            font-size 9px
            font-weight normal
            line-height 9px
            text-align right
            letter-spacing 0px
            color #FF6400
      .es-ticket-right
        display flex
        flex-direction row
        align-items center
        .es-ticket-remainder
          position relative
          margin-right 12px
          font-family PingFang SC
          font-size 14px
          font-weight normal
          line-height 16px
          letter-spacing 0px
          color #666666
        .es-ticket-btn
          background #FF6400
          width 65px
          height 33px
          border-radius 7px
          font-family PingFang SC
          font-size 14px
          font-weight 500
          line-height 33px
          text-align center
          letter-spacing 0px
          color #FFFFFF
    .es-seat-type-name
      color #1473FF
    .recommend
      background #F2F6F9
      border-radius 7px
      margin -5px 2px 0 2px
      padding 12px 14px
      position relative
      max-width 100%
      &::before
        content: ''
        position absolute
        border-left 8px solid transparent
        border-right 8px solid transparent
        border-bottom 8px solid #F2F6F9
        left 30px
        top -6px
      &-tips
        display flex
        align-items center
        font-size 11px
        color #333333
        font-weight 400
      &-gap
        background #CCCCCC
        width 0.5px
        height 10px
        margin 0.5px 8px
</style>

<script name="json">
  module.exports = {
    usingComponents: {
      'price-detail-info-alter': '@/components/price-detail-info-alter',
      'guide-tips': '@/pages/search/components/guide-tips',
      'marke-order-guide': '@/components/marke-order-guide',
      'hl-text': '@/components/hl-text',
      'more-less-guide': '@/components/recommend-ticket/more-less-guide',
      'Privacy': '@/pages/train-detail/components/privacy',
    }
  }
</script>